import React from "react";
import { FaQuoteLeft } from "react-icons/fa";
import { LuUserRound } from "react-icons/lu";

const ReviewCard = ({ text, name, role, avatar }) => {
  return (
    <div className="flex h-full min-h-[320px] flex-col rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition-all sm:min-h-[340px] sm:p-6 lg:min-h-[360px] lg:p-8">
      {/* Top */}
      <div className="flex-shrink-0">
        <FaQuoteLeft className="text-primary text-xl sm:text-2xl" />
      </div>

      {/* Content */}
      <div className="mt-4 flex flex-1 flex-col">
        <p className="text-dark line-clamp-5 flex-1 text-sm leading-7 sm:text-base">
          {text}
        </p>

        {/* Footer */}
        <div className="mt-6 flex items-center gap-3 border-t border-gray-100 pt-4">
          {avatar ? (
            <img
              src={avatar}
              alt={name || "Review user"}
              className="size-10 flex-shrink-0 rounded-full object-cover sm:size-12"
            />
          ) : (
            <div className="bg-primary/10 text-primary flex size-10 flex-shrink-0 items-center justify-center rounded-full sm:size-12">
              <LuUserRound className="size-5" />
            </div>
          )}

          <div className="min-w-0">
            <h4 className="text-dark truncate text-sm font-semibold sm:text-base">
              {name}
            </h4>

            <p className="truncate text-xs text-gray-500 sm:text-sm">{role}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
